import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-sans/700.css';
import './index.css';
import App from './App';
import { configureStore } from '@reduxjs/toolkit';
import reducer from './store/reducer'
import { Provider } from 'react-redux';
import './utils/setupAxios';
import { ThemeProvider } from './context/ThemeContext';
import { ConfirmProvider } from './context/ConfirmContext';

const APP_ENV = process.env.NODE_ENV;
if (process.env.NODE_ENV !== 'production') {
  console.log('APP_ENV: ', process.env);
}


global.APP_ENV = APP_ENV;

const store = configureStore({ reducer, devTools: process.env.NODE_ENV !== 'production' });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ThemeProvider>
      <ConfirmProvider>
        <App />
      </ConfirmProvider>
    </ThemeProvider>
  </Provider>
);
